module.exports = __webpack_public_path__ + "media/video_homebanner.6807bc04.mp4";